import React from 'react';
import * as XLSX from 'xlsx';
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import ModalBody from "../common/ModalBody";
import ModalHeader from "../common/ModalHeader";

function UploadExcel(props) {
  const [data, setData] = React.useState(null);

  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    const reader = new FileReader();

    reader.onload = (event) => {
      const workbook = XLSX.read(event.target.result, { type: 'binary' });
      const sheetName = workbook.SheetNames[0];
      const sheet = workbook.Sheets[sheetName];
      const sheetData = XLSX.utils.sheet_to_json(sheet);
      setData(sheetData);
    };

    reader.readAsBinaryString(file);
  };

  const { show, onHide, handleFileUploadData } = props;
  return (
    <>
      <Modal {...props} show={show} onHide={onHide} animation={false} backdrop="static" size="lg">
        <ModalHeader
          title={"UPLOAD DATA"}
        ></ModalHeader>
        <ModalBody>
          <input className="mx-3" type="file" onChange={handleFileUpload} />
          <Button
            class="accordion-button"
            type="button"
            variant="secondary"
            onClick={() => handleFileUploadData(data)}
          >
            Upload
          </Button>
        </ModalBody>
      </Modal>
    </>
  );
}

export default UploadExcel;
